import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import withAuth from "services/withAuth";

import Dashboard from "views/Dashboard";
import Auth from "views/Auth";
import PasswordResetToken from "views/PasswordResetToken";
import Taxi from "views/Taxi";
import Legal from "views/Legal";
import MapView from "views/MapView";

const AdminRedirect = () => {
  window.location.href = "/api/admin";
  return null;
};

const Router = (_props) => {
  return (
    <SnackbarProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/taxi" element={<Taxi />} />
          <Route path="/legal/*" element={<Legal />} />
          <Route path="/auth/*" element={<Auth />} />
          <Route path="/reset/*" element={<PasswordResetToken />} />
          <Route
            path="/dashboard"
            element={<Navigate to="/dashboard/start" replace />}
          />
          <Route
            path="/dashboard/*"
            element={React.createElement(withAuth(Dashboard))}
          />
          <Route path="/map" element={<MapView />} />
          <Route path="/api/admin" element={<AdminRedirect />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/register"
            element={<Navigate to="/auth/register" replace />}
          />
          <Route
            path="/register/user"
            element={<Navigate to="/auth/register/user" replace />}
          />
          <Route
            path="/login"
            element={<Navigate to="/auth/login" replace />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </SnackbarProvider>
  );
};

export default Router;
